var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "_ngcontent-ng-c755036029": "",
    id: "radio_on_light",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 32 32",
    className: "primaryTag",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "_ngcontent-ng-c755036029": "",
    id: "rectangle",
    width: 64,
    height: 64,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "_ngcontent-ng-c755036029": "",
    id: "radio_on",
    d: "M16,9a7,7,0,1,0,7,7,6.932,6.932,0,0,0-7-7Zm0-7A14,14,0,1,0,30,16,14.041,14.041,0,0,0,16,2Zm0,25.2A11.2,11.2,0,1,1,27.2,16,11.233,11.233,0,0,1,16,27.2Z",
    fill: "#353737",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoi);
export default __webpack_public_path__ + "static/media/poi.c74fee4adec36244c665ca0b2032db52.svg";
export { ForwardRef as ReactComponent };